export default "__VITE_ASSET__d8cca867__"